import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';

import PhotoUploadPanel from './PhotoUploadPanel'

function toBase64(photoBuf) {
  return btoa(photoBuf.reduce((data, byte) => data + String.fromCharCode(byte), ''));
}

function PhotoUploadDialog(props) {
  const appState = useSelector((state)=>state.app);
  const isOpen = props.isOpen;

  const netId = appState.me.netid?.netid;
  const applicationId = props.photoInput?.applicationId;
  const allowReupload = props.photoInput?.allowReupload;
  const photoBuf = props.photoInput?.photoBuf;

  const imgSrc = !!photoBuf ? `data:image/png;base64,${toBase64(photoBuf)}` : null;

  const [newPhoto, setNewPhoto] = React.useState(null);

  useEffect(() => {
    if (!!photoBuf) setNewPhoto(null);
  }, [photoBuf]);

  const onDownloadClicked = () => {
    if (!!imgSrc) {
      var a = document.createElement("a");
      a.href = imgSrc;
      a.download = `${netId.toUpperCase()}_${applicationId}.png`;
      a.click();
    }
  }

  const options = [
    {
      title: 'Close',
      icon: CloseIcon,
      iconColor: 'grey',
      visible: true,
      action: props.onClose,
    },
    {
      title: 'Download',
      icon: DownloadIcon,
      iconColor: (theme) => theme.palette.primary[600],
      visible: true,
      action: onDownloadClicked,
    },
    {
      title: 'Upload',
      icon: UploadIcon,
      iconColor: (theme) => theme.palette.primary[600],
      visible: allowReupload && newPhoto,
      action: () => { !!newPhoto && props.onUpload(newPhoto) },
    },
  ]

  return (
    !!photoBuf && <Dialog
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClose={!!props.onClose ? props.onClose : null}
    >
      <DialogTitle id="alert-dialog-title">
        Photo
        {
          options.map((option, i) => (
            !!option.visible && <IconButton key={i}
            sx={{
              position: 'absolute',
              right: (i * 40 + 13),
              top: 13,
              color: option.iconColor,
            }}
            alt={option.title}
            onClick={option.action}
          >
            <option.icon />
          </IconButton>
          ))
        }
      </DialogTitle>
      <DialogContent>
        <PhotoUploadPanel
          photo={newPhoto ?? imgSrc}
          disabled={!allowReupload}
          allowReupload={allowReupload}
          onChange={(evt) => setNewPhoto(evt.target.value)}
        />
      </DialogContent>
    </Dialog>
  );
}

export default PhotoUploadDialog;
